/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export default function reflowChartsBeforePrint(Highcharts: any): void {
  if (window.matchMedia) {
    const mediaQueryList = window.matchMedia('print');
    mediaQueryList.addListener(function matchMediaPrint(mql) {
      if (mql.matches) {
        Highcharts.charts.forEach((c: any) => {
          if (c) {
            c.reflow();
          }
        });
      }
    });
  }
}
